// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3zqIG","label":"Section_label__3Jwuj","contentWrap":"Section_contentWrap__3FnEg","footer":"Section_footer__vJSXV","footerInner":"Section_footerInner__14XOd"};